/**
 * Set method
 */

const setDeviceClass = require('./common/device_class');
const fixedMenu = require('./plug-in/fixed_menu');
const pageTopScroll = require('./plug-in/page_top_scroll');

setDeviceClass();
fixedMenu();
pageTopScroll();

// docCookies();

// jQuery plug-in
require('./plug-in/check_on_button');
require('./plug-in/contents_accordion');
require('./plug-in/fixed_menu');
require('./plug-in/menu_controller');
require('./plug-in/smooth_page_scroll');
require('./plug-in/responsive_helper_set');

// Run on all pages
$(() => {
  // ハンバーガーメニュー
  $('#oNav').menuController();
  $('#gNav').smoothPageScroll();

  // 電話リンク・テーブルの横スクロール対応
  $('body').responsiveHelperSet();
});
